import { cos, sin, TWO_PI } from "./math/Math"

// bro how many divisions do you really need
const TABLE_SIZE = 128

const sinTable = new Float32Array(TABLE_SIZE)
const cosTable = new Float32Array(TABLE_SIZE)

for (let i = 0; i < TABLE_SIZE; i++) {
  const angle = (i / TABLE_SIZE) * TWO_PI
  sinTable[i] = sin(angle)
  cosTable[i] = cos(angle)
}

const INV_TWO_PI = 1 / TWO_PI  // precompute for speed

export function sinCached(rad: number): number {
  let idx = (rad * INV_TWO_PI) * TABLE_SIZE
  idx = idx - Math.floor(idx)  // get fractional part only, in [0,1)
  return sinTable[(idx * TABLE_SIZE) | 0]
}

export function cosCached(rad: number): number {
  let idx = (rad * INV_TWO_PI) * TABLE_SIZE
  idx = idx - Math.floor(idx)
  return cosTable[(idx * TABLE_SIZE) | 0]
}
